import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class ProcessAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "Process";

  /** author: ĐVThi
   *  Create date: 21/02/2021
   *  Lấy danh sách tài sản theo nhân viên để thu hồi
   */
  getAssetListforReduce(strListEmployeeID) {
    let request = {
      url: [this.getAPIUrl() + "/get-asset-reduce"].join("/"),
      data: strListEmployeeID,
    };

    return httpClient.postAsync(request);
  }

  /** author: ĐVThi
   *  Create date: 21/02/2021
   * 	Cấp phát hành loạt tài sản
   */
  getAssetList(payload) {
    let request = {
      url: this.getAPIUrl() + "/asset-list",
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /** author: ĐVThi
   *  Create date: 04/02/2021
   * Cấp phát hành loạt tài sản
   */
  multiAllocationEmployee(payload) {
    let request = {
      url: [this.getAPIUrl(), "multi-allocation"].join("/"),
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }

  /** author: ĐVThi
   * Create date: 04/02/2021
   * thu hồi hành loạt tài sản
   */
  multiReduceEmployee(payload) {
    let request = {
      url: [this.getAPIUrl(), "multi-reduce"].join("/"),
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }
}

export default new ProcessAPI();
